import React, { FC, ReactNode, useState } from 'react';
import {
    Card,
    CardDescription,
    CardImg,
    CardLinks,
    CardTextContent,
    CardTitle,
    CardTitleContainer,
    IndustryLink,
} from '../IndustriesPageStyle';
import placeHolder from '../../../static/images/placeholder.jpg';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import { TitleIcons } from './IndustriesCardStyle';
import { FieldConnectedNodesInterface, IndustryItemInterface } from '../../../interfaces/industries';
import { urlForImage } from '../../../utils/urlForImage';
import { useI18next } from 'gatsby-plugin-react-i18next';

interface IndustriesCardProps {
    cardData: IndustryItemInterface;
}

const IndustriesCard: FC<IndustriesCardProps> = ({ cardData: { field_image, name, description, connected_nodes } }) => {
    const [isActive, setIsActive] = useState(false);
    const { language } = useI18next();

    const displayCardLinks = (): ReactNode => (
        <CardLinks>
            {connected_nodes?.map((link: FieldConnectedNodesInterface, index: number) => (
                <IndustryLink key={link?.title ?? index} to={link?.url?.length > 0 ? `/${language}${link.url}` : '#'}>
                    {link?.title}
                </IndustryLink>
            ))}
        </CardLinks>
    );

    return (
        <Card>
            <CardTitleContainer isNotContactCard={true} onClick={() => setIsActive((isActive) => !isActive)}>
                <TitleIcons>{isActive ? <IoIosArrowDown /> : <IoIosArrowForward />}</TitleIcons>
                <CardTitle isNotContactCard={true}>{name}</CardTitle>
            </CardTitleContainer>
            <CardImg
                src={
                    field_image?.hasOwnProperty('field_media_image') && field_image?.field_media_image?.length > 0
                        ? urlForImage(field_image?.field_media_image)
                        : placeHolder
                }
                alt={field_image?.alt ?? 'card img'}
            />
            <CardTextContent isActive={isActive}>
                <CardDescription dangerouslySetInnerHTML={{ __html: description }}></CardDescription>
                {connected_nodes?.length > 0 && displayCardLinks()}
            </CardTextContent>
        </Card>
    );
};

export default IndustriesCard;
